import { Dispatch } from "redux";
import {
    setAdaptiveAuthenticationSearchResults,
    setAdaptiveAuthenticationSearchResultsLoading
} from "@redux/actions/adaptive-authentication-actions";
import { getAdaptiveAuthenticationResultsRequest } from "@requests/reports/get-adaptive-authentication-results";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";
import { SERVER_DATE_FORMAT } from "@constants/date-formats";
import startOfDay from "date-fns/startOfDay";
import endOfDay from "date-fns/endOfDay";
import format from "date-fns/format";
import { formatAdaptiveAuthenticationSearchResults } from "@formatters/adaptive-authentication/adaptive-authentication-search-results-formatter";

export const getAdaptiveAuthenticationResultsReduxRequest = (dispatch: Dispatch) => async (
    companyId: string,
    rpServiceId: string,
    workflowId: string,
    startDate: Date,
    endDate: Date
) => {
    dispatch(setAdaptiveAuthenticationSearchResultsLoading(true));
    const { data, error } = await getAdaptiveAuthenticationResultsRequest(
        companyId,
        rpServiceId,
        workflowId,
        format(startOfDay(startDate), SERVER_DATE_FORMAT),
        format(endOfDay(endDate), SERVER_DATE_FORMAT),
        SERVER_DATE_FORMAT
    );
    if (data) {
        const formattedAdaptiveAuthenticationSearchResults = formatAdaptiveAuthenticationSearchResults(data);
        dispatch(setAdaptiveAuthenticationSearchResults(formattedAdaptiveAuthenticationSearchResults));
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.getAdaptiveAuthenticationResults.error.title,
                resources.requests.getAdaptiveAuthenticationResults.error.message
            );
        }
        dispatch(setAdaptiveAuthenticationSearchResultsLoading(false));
    }
};